// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetIsAddingProductToCartParameter } from "@store/Framework/Store/Store/Components/PartFinder/Handlers/SetIsAddingProductToCart";
import PartFinderState from "@store/Framework/Store/Store/Components/PartFinder/PartFinderState";
import { PartModel, ProductAndQuantityModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: PartFinderState = {
    partFinderDrawerOpen: false,
    partFinderModalOpen: false,
    part: undefined,
    tab: undefined,
    isAddingProductToCart: false,
};

const actions = {
    "Store/Components/PartFinder/DispatchBeginOpenPartFinder": (draft: Draft<PartFinderState>) => {
        delete draft.part;
        delete draft.tab;
    },
    "Store/Components/PartFinder/TogglePartFinderDrawer": (draft: Draft<PartFinderState>) => {
        draft.partFinderDrawerOpen = !draft.partFinderDrawerOpen;
    },
    "Store/Components/PartFinder/ClosePartFinderDrawer": (draft: Draft<PartFinderState>) => {
        draft.partFinderDrawerOpen = false;
        draft.part = undefined;
        draft.tab = undefined;
    },
    "Store/Components/PartFinder/OpenPartFinderDrawer": (draft: Draft<PartFinderState>) => {
        draft.partFinderDrawerOpen = true;
    },
    "Store/Components/PartFinder/ClosePartFinderModal": (draft: Draft<PartFinderState>) => {
        draft.productToAddToModal = undefined;
        draft.partFinderModalOpen = false;
        draft.productQty = "0";
    },
    "Store/Components/PartFinder/OpenPartFinderModal": (
        draft: Draft<PartFinderState>,
        action: { productQty: string },
    ) => {
        draft.partFinderModalOpen = true;
        draft.productQty = action.productQty;
    },
    "Store/Components/PartFinder/ResetProductToAddToModal": (draft: Draft<PartFinderState>) => {
        draft.productToAddToModal = undefined;
    },
    "Store/Components/PartFinder/SetProductToAddToModal": (
        draft: Draft<PartFinderState>,
        action: { productToAdd: ProductAndQuantityModel },
    ) => {
        draft.productToAddToModal = action.productToAdd;
    },
    "Store/Components/PartFinder/DispatchPartFinderDrawer": (
        draft: Draft<PartFinderState>,
        action: { part: PartModel; tab: string },
    ) => {
        draft.part = action.part;
        draft.tab = action.tab;
    },
    "Store/Components/PartFinder/DispatchSetIsAddingProductToCart": (
        draft: Draft<PartFinderState>,
        action: SetIsAddingProductToCartParameter,
    ) => {
        draft.isAddingProductToCart = action.isAddingProduct;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type PartFinderActions = Parameters<typeof reducer>[1];
export default reducer;
